angular
    .module('dnecom', [
        'dnecom.imgix',
        'dnecom.media',

        'angular-confirm',
        'ngAnimate',
        'ngMessages',
        'datatables',
        'ui',
        'ngFileUpload',
        'ui.select2',
        'ui.select',
        'tc.chartjs',
        'colorpicker.module',
        'ng-slide-down',
        'ui.bootstrap',
        'ngclipboard',
        'angular-timezone-select',
        'angularUtils.directives.dirPagination',
        'ngCookies',
        'ngSanitize',
        'angucomplete-alt',
        'uiSwitch',
        'treeControl',
        'dnecom.common'
    ])
    .config(["$animateProvider", "$provide", "$httpProvider", function ($animateProvider, $provide, $httpProvider) {
        $animateProvider.classNameFilter(/angular-animate/);

        var formDecorator = function ($delegate) {
            var fn = $delegate[0].controller.prototype;

            if (!('$setTouched' in fn)) fn.$setTouched = function () {
                if (this.$invalid) {
                    _.values(this.$error).forEach(function (controls) {
                        controls.forEach(function (control) {
                            if (control) {
                                control.$setTouched()
                            }
                        })
                    })
                }
            };

            return $delegate
        };
        formDecorator.$inject = ["$delegate"];

        $httpProvider.interceptors.push(["$q", function($q) {
            return {
                'responseError': function(rejection) {
                    if (rejection.status != 422) {
                        return $q.reject(rejection);
                    }

                    if (typeof Sentry !== 'undefined') {
                        Sentry.withScope(scope => {
                            scope.setExtra('request', rejection.config);
                            scope.setExtra('response', rejection.data);
                            Sentry.captureMessage('XHR Validation Error', 'error');
                        });
                    }

                    return $q.reject(rejection);
                }
            };
        }]);

        $provide.decorator('formDirective', formDecorator);
        $provide.decorator('ngFormDirective', formDecorator);

        $provide.decorator('$q', ["$delegate", function ($delegate) {
            var defer = $delegate.defer;

            $delegate.defer = function () {
                var deferred = defer();
                
                var STATES = {
                    REJECTED: -1,
                    PENDING: 0,
                    FULFILLED: 1
                };

                deferred.promise.state = deferred.state = STATES.PENDING;

                deferred.promise.then(function () {
                    deferred.promise.state = deferred.state = STATES.FULFILLED;
                }, function () {
                    deferred.promise.state = deferred.state = STATES.REJECTED;
                });

                deferred.promise.__proto__.pending = function () {
                    return deferred.promise.state == STATES.PENDING;
                };
                
                deferred.promise.__proto__.rejected = function () {
                    return deferred.promise.state == STATES.REJECTED;
                };
                
                deferred.promise.__proto__.fulfilled = function () {
                    return deferred.promise.state == STATES.FULFILLED; 
                };

                deferred.promise.__proto__.finished = function () {
                    return deferred.promise.state == STATES.FULFILLED 
                        || deferred.promise.state == STATES.REJECTED;
                };

                return deferred;
            };

            return $delegate;
        }]);

        $.extend(true, $.fn.DataTable.defaults, {
            pagingType: 'simple_numbers',
            lengthChange: false,
            displayLength: 15,
            infoEmpty: 'Showing <strong>0 to 0</strong> of 0 entries',
            language: {
                info: 'Showing <strong>_START_ to _END_</strong> of _TOTAL_ entries',
                paginate: {
                    previous: '<i class="fa fa-angle-left"></i>',
                    next: '<i class="fa fa-angle-right"></i>'
                },
                processing: '<div class="progress-circle-indeterminate progress-circle-primary"></div>',
                loadingRecords: '<div class="progress-circle-indeterminate progress-circle-primary"></div>'
            },
            bFilter: true
        });
    }])
    .run(["$confirmModalDefaults", "$rootScope", function ($confirmModalDefaults, $rootScope) {
        $confirmModalDefaults.template = '<div class="modal-header"><button type="button" class="close" aria-label="Close" ng-click="cancel();"><i class="m-t-5 pg-close_line fs-16"></i></button><h5 class="modal-title">{{data.title}}</h5></div><div class="p-t-25 modal-body">{{data.text}}</div><div class="modal-footer"><button class="btn btn-danger" ng-click="ok()">{{data.ok}}</button><button class="btn btn-default" ng-click="cancel()">{{data.cancel}}</button></div>';
        $confirmModalDefaults.windowClass = 'modal-danger';

        $rootScope.hasErrors = function(element) {
            return element.$invalid && element.$touched;
        }
    }])
    .filter('local_date', function () {
        return function (dateString) {
            return moment(dateString, 'YYYY-MM-DD HH:mm:ss Z');
        };
    });

angular.module('contextMenu', []); //stub for treeControl
